/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ApplicationAnswerSaveRequest = {
    status?: ApplicationAnswerSaveRequest.status;
    spentTime?: number;
    lastAnswerQuestion?: string;
    lastAnswerPage?: string;
    lastAnswerPageNumber?: number;
    answer?: Record<string, Record<string, any>>;
};

export namespace ApplicationAnswerSaveRequest {

    export enum status {
        CREATED = 'CREATED',
        IN_PROGRESS = 'IN_PROGRESS',
        CANCELLED = 'CANCELLED',
        SUBMITTED = 'SUBMITTED',
        RECREATED = 'RECREATED',
    }


}

